import React, { useEffect } from "react";
import $ from "jquery";
import "../style/errorBox.css";

export default function ErrorBox(props) {
  let errorBox = $(".errorBox");
  let errorBoxText = document.querySelector(".errorBoxText");

  useEffect(() => {
    if (props.type == "hideErrorBox") {
      removeBusyBody();
      errorBox.hide();
    } else if (props.type == "addingNoteFail") {
      errorBox.hide();
      errorBoxText.innerText = "Klarte ikke legge inn ny note.";
      removeBusyBody();
      errorBox.fadeIn(500).delay(7000).fadeOut(1000);
    } else if (props.type == "removingNoteFail") {
      errorBox.hide();
      errorBoxText.innerText = "Sletting feilet.";
      removeBusyBody();
      errorBox.fadeIn(500).delay(7000).fadeOut(1000);
    } else if (props.type == "loadingFail") {
      errorBox.hide();
      errorBoxText.innerText =
        "Ktext får feil for lasting av notater til tillegget. Start dokumentet på nytt. Hvis feilen vedvarer, vennligst kontakt support.";
      removeBusyBody();
      errorBox.fadeIn(500);
    } else if (props.type == "gettingDocumentFail") {
      errorBox.hide();
      errorBoxText.innerText = "Henting av dokument feilet. Ta kontakt med Karnov dersom det haster.";
      removeBusyBody();
      errorBox.fadeIn(500);
    } else if (props.type == "FailedPing") {
      errorBox.hide();
      errorBoxText.innerText = "Varselet ditt kunne ikke sendes.";
      errorBox.fadeIn(500).delay(5000).fadeOut(1000);
    } else if (props.type == "ApproveReviewFailed") {
      errorBox.hide();
      errorBoxText.innerText = "Godkjenning mislyktes.";
      errorBox.fadeIn(500).delay(5000).fadeOut(1000);
    } else if (props.type == "SetReadyForPublishFailed") {
      errorBox.hide();
      errorBoxText.innerText = "Angi klar for publisering mislyktes.";
      errorBox.fadeIn(500).delay(5000).fadeOut(1000);
    } else if (props.type == "ChangeStatusFailed") {
      errorBox.hide();
      errorBoxText.innerText = "Endring av status mislyktes.";
      errorBox.fadeIn(500).delay(5000).fadeOut(1000);
    } else if (props.type == "inactivity") {
      errorBox.hide();
      errorBoxText.innerText =
        "Ktext har vært for lenge uten aktivitet. Du må lukke tillegget (Ktext) og åpne det på nytt igjen.";
      errorBox.fadeIn(500);
      document.querySelector("#wholePage").classList.add("lockKword");
    } else if (props.type == "initiatingNoteIdFail") {
      errorBox.hide();
      errorBoxText.innerText =
        "Ktext får feil for synkronisering av notater. Start dokumentet på nytt. Hvis feilen vedvarer, vennligst kontakt support.";
      errorBox.fadeIn(500).delay(10000).fadeOut(1000);
    }
  }, [props.type]);

  const removeBusyBody = () => {
    let lovtekstDiv = document.querySelector("#lovtekst");
    if (lovtekstDiv) {
      const busyBodyStatus = lovtekstDiv.classList.contains("busyBody");
      if (busyBodyStatus) {
        lovtekstDiv.classList.remove("busyBody");
      }
    }
  };

  const hideErrorBox = () => {
    $(".errorBox").hide();
  };

  return (
    <div className="errorBox alert alert-info alert-dismissible fade show">
      <p style={{ display: "inline" }} className="errorBoxText">
        Message
      </p>
      <button type="button" className="btn-close" onClick={hideErrorBox}></button>
    </div>
  );
}
